Namespace 'Monitoring.Reports.Publications.Summary'

class Monitoring.Reports.Publications.Summary.UsersView extends Backbone.View

  className: 'content-section content-embedded content-users'
  template: JST['backbone/templates/monitoring/reports/publications/summary/users']
  twitterTemplate: JST['backbone/templates/monitoring/reports/publications/summary/twitter_users']

  initialize: (@options = {}) ->
    # just set @options
    # @options.tags form is [code, name, count_label]

  avatars: ->
    fb_ids = _.map(@options.contents, (content) -> ["https://graph.facebook.com/#{content.user}/picture?height=50", "https://www.facebook.com/#{content.user}"])
    fb_ids = _.uniq(fb_ids, (item) -> item[0])
    _.first(fb_ids, 8) # No more than 8 icons in the avatar slider

  twitter_avatars: ->
    fb_ids = _.map @options.contents, (content) ->
      data = content.full_content.data
      image_url = data.actor && data.actor.image || data.user && data.user.profile_image_url
      [image_url, "https://twitter.com/#{content.user}"]
    fb_ids = _.uniq(fb_ids, (item) -> item[0])
    _.first(fb_ids, 8) # No more than 8 icons in the avatar slider

  friendly_name_for: (tag_code) ->
    _.find(@options.tags, (tag_data) -> tag_data[0] == tag_code)[2].toLowerCase()

  counts: ->
    tags = _.map(@options.tags, (tag_data) -> tag_data[0])
    _.map(tags, (tag) =>
      friendly_name = @friendly_name_for(tag)
      count = _.filter(@options.contents, (content) =>
        _.include(content.full_content.tags, tag)
      ).length
      [count, friendly_name]
    )

  render: ->
    total = @options.contents.length
    @$el.html(@template({ avatars: @avatars(), counts: @counts(), total: total }))
    return this

  render_twitter: ->
    total = @options.contents.length
    @$el.html(@twitterTemplate({ avatars: @twitter_avatars(), counts: @counts(), total: total }))
    return this
